import { Typography } from 'antd';
import React, { memo, useEffect } from 'react';
import { formatCurrency } from 'utils/constants/functions';

interface Iprops {
  value: any;
  color?: 'black' | 'white' | 'green' | 'blue' | 'blueblack' | 'red' | string;
  size?: 'xs' | 'sm' | 'base' | 'lg' | 'xl' | '2xl';
  weight?: 'thin' | 'light' | 'normal' | 'medium' | 'bold';
  title?: boolean;
  isNumber?: boolean;
  className?: string;
  lineHeight?: string;
}

const TextCustom = (props: Iprops) => {
  const Text = Typography;
  const {
    value,
    color = 'text-black',
    title = false,
    lineHeight = 'leading-5',
  } = props;
  const size = props?.size || (title ? 'text-xl' : 'text-sm');
  const weight = props?.weight || (title ? 'bold' : 'normal');

  let colorText = color.toString();

  if (color === 'white') {
    colorText = 'text-white';
  } else if (color === 'green') {
    colorText = 'text-[#038F00]';
  } else if (color === 'blue') {
    colorText = 'text-[#0077CC]';
  } else if (color === 'blueblack') {
    colorText = 'text-[#003056]';
  } else if (color === 'red') {
    colorText = 'text-[#DC362E]';
  }

  // useEffect(() => {
  //   console.log('colorText', colorText);
  //   console.log('size', size);
  //   console.log('weight', weight);
  //   console.log('title', title);
  // }, []);
  return (
    <Text
      className={`inline ${colorText} font-${weight} ${size} ${lineHeight} !p-0 !m-0 ${props.className}`}
    >
      {props.isNumber && !isNaN(parseFloat(value))
        ? formatCurrency({ value: value })
        : value}
    </Text>
  );
};

export default memo(TextCustom);

{
  /* <Text className="text-[#003056] font-normal text-sm">
Tổng đội
</Text>
<Text
className="text-[#003056] font-bold text-2xl !p-0 !m-0"
style={{ lineHeight: '20px' }}
>
5
</Text> */
}
